var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "600", "retain-focus": false },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "text-white",
                    attrs: { small: "", color: "red" },
                  },
                  on
                ),
                [_vm._v("キャンセル")]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.confimDialog,
        callback: function ($$v) {
          _vm.confimDialog = $$v
        },
        expression: "confimDialog",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline grey lighten-2" }, [
            _vm._v("\n      現在受講中のコース閲覧ができなくなります。\n    "),
          ]),
          _vm._v(" "),
          _c("v-card-actions", [
            _c(
              "div",
              { staticClass: "w-100" },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "large",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "me-2", attrs: { color: "red" } },
                          [_vm._v("info")]
                        ),
                        _vm._v(
                          "\n            コースの受講ができなくなります\n          "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "me-2", attrs: { color: "red" } },
                          [_vm._v("info")]
                        ),
                        _vm._v(
                          "\n            学習履歴が無くなります\n          "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "me-2", attrs: { color: "red" } },
                          [_vm._v("info")]
                        ),
                        _vm._v(
                          "\n            サポートは受けられなくなります\n          "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "me-2", attrs: { color: "red" } },
                          [_vm._v("info")]
                        ),
                        _vm._v(
                          "\n            関連する優待なども受けられなくなります\n          "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex" }, [
                      _vm._v(
                        "\n            よろしければ理由をお教えください\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.message,
                          expression: "message",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { rows: "5" },
                      domProps: { value: _vm.message },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.message = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "text-white mt-4",
                    attrs: { color: "red" },
                    on: { click: _vm.onDelete },
                  },
                  [
                    _vm._v(
                      "\n          上を理解した上でキャンセルする\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }